export default __webpack_public_path__ + "static/media/dojang2.fa201c3b.jpg";